const actions = {
  NOT_AUTHORIZED: "NOT_AUTHORIZED",
  NO_DEVICE: "NO_DEVICE",
  SAVE_JWT_TOKEN: "SAVE_JWT_TOKEN",

  SET_WELCOME_MENU_SEEN: "SET_WELCOME_MENU_SEEN",

  START_SELECT_DEVICE_REQUEST: "START_SELECT_DEVICE_REQUEST",
  END_SELECT_DEVICE_REQUEST: "END_SELECT_DEVICE_REQUEST",
  SUCCESS_SELECT_DEVICE_REQUEST: "SUCCESS_SELECT_DEVICE_REQUEST",
  FAIL_SELECT_DEVICE_REQUEST: "FAIL_SELECT_DEVICE_REQUEST",

  LOAD_DEVICES: "LOAD_DEVICES",
  START_LOAD_DEVICES_REQUEST: "START_LOAD_DEVICES_REQUEST",
  END_LOAD_DEVICES_REQUEST: "END_LOAD_DEVICES_REQUEST",
  FAIL_LOAD_DEVICES_REQUEST: "FAIL_LOAD_DEVICES_REQUEST",

  START_LOAD_PLAYLISTS_REQUEST: "START_LOAD_PLAYLISTS_REQUEST",
  FAIL_LOAD_PLAYLISTS_REQUEST: "FAIL_LOAD_PLAYLISTS_REQUEST",
  END_LOAD_PLAYLISTS_REQUEST: "END_LOAD_PLAYLISTS_REQUEST",
  SUCCESS_LOAD_PLAYLISTS_REQUEST: "SUCCESS_LOAD_PLAYLISTS_REQUEST",

  START_SET_PLAYLIST_REQUEST: "START_SET_PLAYLIST_REQUEST",
  END_SET_PLAYLIST_REQUEST: "END_SET_PLAYLIST_REQUEST",
  SUCCESS_SET_PLAYLIST_REQUEST: "SUCCESS_SET_PLAYLIST_REQUEST",
  FAIL_SET_PLAYLIST_REQUEST: "FAIL_SET_PLAYLIST_REQUEST",

  START_SET_PARTY_NAME_REQUEST: "START_SET_PARTY_NAME_REQUEST",
  END_SET_PARTY_NAME_REQUEST: "END_SET_PARTY_NAME_REQUEST",
  SUCCESS_SET_PARTY_NAME_REQUEST: "SUCCESS_SET_PARTY_NAME_REQUEST",
  FAIL_SET_PARTY_NAME_REQUEST: "FAIL_SET_PARTY_NAME_REQUEST",

  LOAD_PRIVATE_CREDENTIALS: "LOAD_PRIVATE_CREDENTIALS",
  FAIL_LOAD_PRIVATE_CREDENTIALS: "FAIL_LOAD_PRIVATE_CREDENTIALS",
};

export default actions;
